if (!customElements.get('quickview-popup')) {
  class QuickviewPopup extends ModalDialog {
    constructor() {
      super();
    }

    handleOpen(event) {
      this.targetElement.innerHTML = '';

      fetch(event.detail.url)
        .then(res => res.text())
        .then((data) => {
          const html = new DOMParser().parseFromString(data, 'text/html');
          const content = html.querySelector('.js-product');

          const input = html.querySelector('.product-variant-id');
          input.disabled = false;

          this.targetElement.innerHTML = content.outerHTML;
        })
        .catch((err) => console.log(err));

      super.show(event.detail.opener);
    }

    handleClose() {
      super.hide();
    }

    connectedCallback() {
      this.targetElement = this.querySelector('.js-quickview-content');
      document.addEventListener('dawn:open-quickview', this.handleOpen.bind(this));

      this.closeButton = this.querySelector('.js-close');
      if (this.closeButton) this.closeButton.addEventListener('click', this.handleClose.bind(this));
    }
  }
  customElements.define('quickview-popup', QuickviewPopup);
}
